import { Link } from "react-router-dom";
import { createRouterLinkAdapter } from "@site-factory/ui";

export const RouterLink = createRouterLinkAdapter(Link);
